var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.clinicId)?_c('v-container',[_c('ClinicProfileDetails',{attrs:{"id":_vm.clinicId}})],1):_c('v-container',[_c('v-alert',{attrs:{"type":"warning","outlined":""}},[_vm._v(" No clinic assigned to your account ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }